import {
  Customer as APICustomer,
  CustomerPopulated as APICustomerPopulated,
} from 'api/domain/entities/Customer';

import { Entity } from 'domain/types/Entity';

export type Customer = Entity<APICustomer>;
export type CustomerPopulated = Entity<APICustomerPopulated>;

export const areAddressesEqual = (
  customer: Pick<
    Customer,
    | 'mailingAddressStreet'
    | 'mailingAddressCity'
    | 'mailingAddressState'
    | 'mailingAddressZip'
    | 'mailingAddressCountry'
    | 'physicalAddressStreet'
    | 'physicalAddressCity'
    | 'physicalAddressState'
    | 'physicalAddressZip'
    | 'physicalAddressCountry'
  >,
): boolean => {
  return (
    customer.mailingAddressStreet === customer.physicalAddressStreet ||
    customer.mailingAddressCity === customer.physicalAddressCity ||
    customer.mailingAddressState === customer.physicalAddressState ||
    customer.mailingAddressZip === customer.physicalAddressZip ||
    customer.mailingAddressCountry === customer.physicalAddressCountry
  );
};
